import { USER_STATE_KEY, UserState } from './user-reducer';

export enum USER_ACTION_TYPE {
  SET_USER_STATE = 'SET_USER_STATE',
  CALL_USER = 'CALL_USER',
  CALL_FILTER_BRANCH = 'CALL_FILTER_BRANCH'
}

export type SetUserStateAction<KeyName extends keyof UserState> = {
  type: USER_ACTION_TYPE.SET_USER_STATE;
  payload: { key: KeyName, value: UserState[KeyName] };
};


export type UserActions = SetUserStateAction<USER_STATE_KEY>;
